import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-udfs-modal',
  templateUrl: './view-udfs-modal.component.html',
  styleUrls: ['./view-udfs-modal.component.sass']
})
export class ViewUdfsModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
